module.exports = __webpack_public_path__ + "static/media/Picture-perfect-Web-Wedding1.70556858.webp";